// Home.js
import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Home = () => {
  const heroImgRef = useRef();
  const aboutImgRef = useRef();

  const handleTilt = (e, imgRef) => {
    if (!imgRef.current) return;
    const rect = imgRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * 10; // max 10 deg
    const rotateY = ((x - centerX) / centerX) * 10; // max 10 deg
    imgRef.current.style.transform = `rotateX(${-rotateX}deg) rotateY(${rotateY}deg) scale(1.08)`;
  };

  const resetTilt = (imgRef) => {
    if (!imgRef.current) return;
    imgRef.current.style.transform = "rotateX(0deg) rotateY(0deg) scale(1)";
  };

  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 hero-text">
              <h5 className="hero-subtitle">Welcome to IMT</h5>
              <h1 className="hero-title">
                Reliable Customer Service, <span>Accurate Results</span>
              </h1>
              <p className="hero-description">
                Integrity Materials Testing (IMT) is a locally owned
                Construction Materials Testing company servicing the Tampa Bay
                area. Speak with a local employee who truly cares about our
                hometown.
              </p>
              <a href="/services" className="btn hero-btn">
                Our Services
              </a>
            </div>

            <div className="col-lg-6 hero-image text-center">
              <img
                ref={heroImgRef}
                src="images/DSC_2306.JPG"
                alt="Hero"
                className="img-fluid hero-tilt"
                onMouseMove={(e) => handleTilt(e, heroImgRef)}
                onMouseLeave={() => resetTilt(heroImgRef)}
                style={{ perspective: "1000px" }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="about-section" id="about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                ref={aboutImgRef}
                src="images/Imt-Home.png"
                alt="About IMT"
                className="img-fluid about-img hero-tilt"
                onMouseMove={(e) => handleTilt(e, aboutImgRef)}
                onMouseLeave={() => resetTilt(aboutImgRef)}
              />
            </div>

            <div className="col-lg-6 about-text">
              <h6 className="about-subtitle">About Us</h6>
              <h2 className="about-title">
                Our Commitment to <span>Quality and Expertise</span>
              </h2>
              <p className="about-description">
                Integrity Materials Testing (IMT) is a locally-owned company in
                Tampa Bay providing construction materials testing services to
                public and private industries, including homeowners,
                contractors, and municipalities. We pride ourselves on excellent
                customer service and accurate results.
              </p>
              <a href="/about" className="btn about-btn">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>

      <style>{`

        .hero-section {
          background: linear-gradient(135deg, #000000ff, #303030ff);
          color: #fff;
          padding: 180px 0;
          position: relative;
          overflow: hidden;
        }
        .hero-section::before {
          content: "";
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
          animation: rotate 20s linear infinite;
        }
        @keyframes rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .hero-text h1 span { color: #077325; text-shadow: 2px 2px 8px rgba(0,0,0,0.3);}
        .hero-subtitle { font-weight: 500; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 15px; opacity: 0; animation: slideInLeft 1s forwards;}
        .hero-title { font-size: 3rem; font-weight: 700; margin-bottom: 25px; opacity: 0; animation: slideInLeft 1.2s forwards;}
        .hero-description { font-size: 1.1rem; line-height: 1.8; margin-bottom: 30px; opacity: 0; animation: slideInLeft 1.4s forwards; color:white;}
        .hero-btn { background: #077325; color: #fff; font-weight: 600; padding: 12px 30px; border-radius: 50px; transition: all 0.4s ease; opacity: 0; animation: slideInLeft 1.6s forwards;}
        .hero-btn:hover { background: transparent; color: #077325; border: 2px solid #077325; transform: scale(1.05);}

  
        .hero-tilt, .about-img {
          border-radius: 20px;
          transition: transform 0.2s ease;
        }


        .about-section { background: #f9f9f9; padding: 100px 0; position: relative;}
        .about-section::after { content: ""; position: absolute; top: 0; right: 0; width: 300px; height: 300px; background: rgba(9,37,83,0.05); border-radius: 50%; z-index: 0;}
        .about-subtitle { color: #092553; font-weight: 600; text-transform: uppercase; margin-bottom: 15px;}
        .about-title { font-size: 2.5rem; font-weight: 700; margin-bottom: 25px;}
        .about-title span { color: #077325;}
        .about-description { font-size: 1.05rem; line-height: 1.8; margin-bottom: 30px;}
        .about-btn { background: #077325; color: #fff; font-weight: 600; padding: 12px 30px; border-radius: 50px; transition: all 0.4s ease;}
        .about-btn:hover { background: transparent; color: #077325; border: 2px solid #077325; transform: scale(1.05);}


        @keyframes slideInLeft { 0% { transform: translateX(-50px); opacity: 0;} 100% { transform: translateX(0); opacity: 1;} }
      `}</style>
    </>
  );
};

export default Home;
